<template>
  <div class="user-trash-list fixed-draggable-dynamic-table-wrapper-height semi-box-border-y">
    <DraggableDynamicTable ref="userListTable"
                            :columns="columnsLabel"
                           :options="options"
                           @filter:remove="setFilter($event, true)"
                           @filter:set="setFilter($event)"
                           @sort:set="setSort($event)"
                           @user:restore="restoreUser($event)"
                           @user:deleted="$refs.deleteConfirmation.showDialog(), selectedUser = $event"
                           v-model="tableData"
    />

    <custom-dialog ref="deleteConfirmation"
                   :title="`${$t('users.general.confirmations.delete.title')}`"
                   :body="`${$t('users.general.confirmations.delete.body', {name: selectedUser.name})}`"
                   @accept="deleteUser(selectedUser)"/>
  </div>
</template>

<script>
import Navbar from '../../../components/navbar/Navbar.vue'
import DraggableDynamicTable from '../../../components/draggableDynamicTable/draggableDynamicTable.vue'
import {deleteUser, getUserTrash, restoreUser} from '@/http/requests/users'
import InsertUser from '@/views/users/insert/InsertUser.vue'
import CustomIcon from '@/components/icon/customIcon.vue'
import CustomModal from '@/components/modal/customModal.vue'
import CustomDialog from '@/components/dialog/customDialog.vue'

export default {
  name: 'UserTrash',
  components: {
    CustomDialog,
    CustomModal,
    CustomIcon,
    InsertUser,
    Navbar,
    DraggableDynamicTable
  },

  metaInfo () {
    return {
      title: this.$t('users.trash.title')
    }
  },

  data () {
    return {
      insertPromptStatus: false,
      options: {
        id: 'employeesList',
        rowKeyField: 'id'
      },
      columnsLabel: [
        {
          field: 'storeAction',
          i18n: 'users.list.table.header.restore',
          color: 'success',
          width: '70px',
          minWidth: 70,
          locked: true,
          fixed: true,
          actions: true,
          showAction: 'always',
          event: 'user:restore',
          action: {
            icon: 'REFRESH',
            iconPack: 'useral',
            color: 'success',
            type: 'button'
          },
          classes: 'mx-auto'
        },
        {
          field: 'deleteAction',
          i18n: 'users.list.table.header.delete',
          color: 'danger',
          width: '70px',
          minWidth: 70,
          align: 'center',
          locked: true,
          fixed: true,
          actions: true,
          showAction: 'always',
          event: 'user:deleted',
          action: {
            icon: 'trash-icon',
            iconPack: 'useral',
            color: 'danger',
            type: 'button'
          },
          classes: 'mx-auto'
        },
        {
          field: 'total_times',
          i18n: 'users.list.table.header.totalTime',
          width: '150px',
          minWidth: 150,
          align: 'center',
          /*filter: true,
          filterType: 'checkbox',
          filterTypes: []*/
          sortable: true,
          filter: true,
          filterTypes: [
            {
              icon: 'EQUAL',
              name: 'برابر باشد',
              id: 1
            },
            {
              icon: 'NOT_EQUAL',
              name: 'برابر نباشد',
              id: 2
            },
            {
              icon: 'GTE',
              name: 'بزرگتر مساوی',
              id: 3
            },
            {
              icon: 'LTE',
              name: 'کوچکتر مساوی',
              id: 4
            }
          ]
        },
        {
          field: 'email',
          i18n: 'users.list.table.header.email',
          width: 'calc((100% / 4))',
          minWidth: 150,
          align: 'center',
          filter: true,
          filterType: 'search',
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              id: 1
            }
          ],
          sortable: true
        },
        {
          field: 'name',
          i18n: 'users.list.table.header.name',
          width: 'calc((100% / 4) * 2)',
          minWidth: 150,
          align: 'center',
          filter: true,
          filterType: 'search',
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              id: 1
            }
          ],
          sortable: true
        },
        {
          field: 'id',
          i18n: 'users.list.table.header.row',
          width: '70px',
          minWidth: 70,
          align: 'center',
          autoIncrement: true,
          fixed: true,
          footer: {
            textType: 'price'
          }
        }
      ],
      loadingTimer: 0,
      endedList: false,
      tableData: [],
      filters: [],
      sorts: [],
      page: 1,
      selectedUser: {},
      actions: {
        toolbar: [],
        leftToolbar: [
          {
            id: {name: 'users'},
            type: 'link',
            icon: 'chevron-left-icon',
            iconPack: 'useral'
          }
        ]
      }
    }
  },

  created () {
    this.getUser()
  },

  mounted () {
    this.$nextTick(() => {
      this.$store.dispatch('updateNavbarActions', this.actions)
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
    })
  },

  methods: {
    getUser () {
      clearTimeout(this.loadingTimer)
      this.loadingTimer = setTimeout(() => {
        if (!this.endedList) {
          this.$refs.userListTable.loadMoreStatus = 'FirstLoad'
          if (this.$refs.userListTable && this.tableData.length === 0) {
            this.$refs.userListTable.loadMoreStatus = 'FirstLoad'
          } else if (this.$refs.userListTable && this.tableData.length > 0) {
            this.$refs.userListTable.loadMoreStatus = 'Loading'
          }
          this.endedList = true
          getUserTrash(this.page, this.filters, this.sorts)
            .then((response) => {
              this.endedList = response.data.pagination.current_page === response.data.pagination.total_pages

              const users = response.data.data
              // const users = []
              users.forEach((user) => {
                this.tableData.push({
                  id: user.id,
                  name: `${user.name || ''} ${user.family || ''}`,
                  email: {
                    value: user.email ? user.email : '',
                    route: user.email ? `mailto:${user.email}` : null,
                    routeType: 'external'
                  },
                  total_times: user.total_times ? user.total_times : 0
                })
              })

              this.page = response.data.pagination.current_page + 1
              const row_index = this.columnsLabel.map((e) => {
                return e.field
              }).indexOf('id')
              this.columnsLabel[row_index].footer.value = response.data.pagination.total

              if (this.$refs.userListTable) this.$refs.userListTable.loadMoreStatus = ''
            })
            .catch(() => {})
        }
      }, 400)

    },
    showUser (user) {
      this.$router.push({name: 'userTaskList', params: {id: user.id, user}})
    },
    setFilter (filters) {
      let filters_list = []
      const attributes = []
      Object.keys(filters).forEach((key) => {
        switch (key) {

        case 'id':
          if (filters[key].search !== '') filters_list.push(`id=${filters[key].search}`)
          break

        case 'name':
          if (filters[key].search !== '') filters_list.push(`fullName=${filters[key].search}`)
          break

        case 'email':
          if (filters[key].search !== '') filters_list.push(`email=${filters[key].search}`)
          break

        case 'total_times':
          if (filters[key].search !== '') filters_list.push(`totalTime=${filters[key].search}${filters[key].type.id > 1 ? `,${filters[key].type.id}` : ''}`)
          break
        }
      })
      filters_list = [filters_list, ...attributes]

      this.filters = filters_list

      this.handleReloadTable()
    },
    setSort (sorts) {
      const sorts_list = []
      Object.keys(sorts).forEach((key) => {
        switch (key) {

        case 'id':
          sorts_list.push(`order[0]=id,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'name':
          sorts_list.push(`order[0]=name,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'email':
          sorts_list.push(`order[0]=email,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'total_times':
          sorts_list.push(`order[0]=total_times,${  sorts[key] ? 'desc' : 'asc'}`)
          break
        }
      })

      if (sorts_list.length === 0) {
        this.sorts.push('order[0]=updated_at,desc')
      }

      this.sorts = sorts_list

      this.handleReloadTable()
    },
    restoreUser (user) {
      restoreUser(user.id).then(() => {
        this.$vs.notify({
          title: this.$t('others.alert.message.title'),
          text: this.$t('users.general.notifications.restore.success'),
          color: 'success',
          time: this.$u.getReadingTime(this.$t('users.general.notifications.restore.success')),
          icon: 'icon-check-circle',
          iconPack: 'feather'
        })

        this.handleReloadTable()
      }).catch(() => {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('users.general.notifications.restore.error'),
          color: 'danger',
          time: this.$u.getReadingTime(this.$t('users.general.notifications.restore.error')),
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
      })
    },
    deleteUser (user) {
      deleteUser(user.id, true).then(() => {
        this.$vs.notify({
          title: this.$t('others.alert.message.title'),
          text: this.$t('users.general.notifications.delete.success'),
          color: 'success',
          time: this.$u.getReadingTime(this.$t('users.general.notifications.delete.success')),
          icon: 'icon-check-circle',
          iconPack: 'feather'
        })

        this.handleReloadTable()
      }).catch(() => {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('users.general.notifications.delete.error'),
          color: 'danger',
          time: this.$u.getReadingTime(this.$t('users.general.notifications.delete.error')),
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
      })
    },
    handleReloadTable () {
      this.tableData = []
      this.page = 1
      this.endedList = false
      this.$nextTick(() => {
        this.getUser()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: calc(100vh - 90px);
}
</style>
